module.exports = __webpack_public_path__ + "static/logos/logo-skiset--color-4365e076139a903ff309ed78388c7b09.svg";